/* 司馬懿傳共用的小工具：這條列傳才有的人物（孟達、卑衍、公孫淵、牛金、胡遵、司馬師）、各家的兵、
 * 天數（日程）、雨幕、旗幟與土山的畫法、讓村民（送信的人）走到某處 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { H } from '../../heroes/define.ts';
import { troop } from '../kit.ts';

const NEUTRAL_C = { armor: '#5a4a3a', sleeve: '#3a3028', cloth: '#3a3028', trim: '#b8a060', pants: '#2a2420', boot: '#2a2018', cape: null, belt: '#5a3a22', metal: '#8e979f', hood: '#3a3028', pole: '#5a3a22', plume: '#b8a060', band: '#b8a060' };
const P = (id, name, sub, faction, role, weapon, look, skills) => H(id, name, sub, faction, role, weapon, Object.assign({ fx: '#ffd8a0' }, look, faction === 'neutral' ? { c: Object.assign({}, NEUTRAL_C, look.c) } : {}), skills);

export const MEN = {
  mengda: P('mengda', '孟達', '新城太守', 'neutral', '戰士', 'sword', { eye: 'narrow', beard: 'mustache', bulk: 1.1, size: 1.1, c: { armor: '#4a5a3a', cloth: '#2e3a26', cape: '#6a7a4a', plume: '#a0b070' } }, [
    ['反覆', 'crescent', '揮劍造成 {120/120/120/120} 傷害。'], ['突圍', 'charge', '衝撞造成 {100/100/100/100} 傷害。'], ['困守', 'spin', '每圈 {55/55/55/55} 傷害。'], ['孤注', 'slam', '{170/170/170} 傷害。']]),
  beiyan: P('beiyan', '卑衍', '公孫淵大將軍', 'neutral', '戰士', 'spear', { eye: 'fierce', beard: 'bushy', bulk: 1.15, size: 1.12, c: { armor: '#4a3a5a', cloth: '#2e2638', cape: '#6a5a7a', plume: '#9a8ab0' } }, [
    ['長槍', 'crescent', '造成 {120/120/120/120} 傷害。'], ['遼騎', 'charge', '衝撞造成 {110/110/110/110} 傷害。'], ['亂刺', 'spin', '每圈 {55/55/55/55} 傷害。'], ['死戰', 'slam', '{180/180/180} 傷害。']]),
  gongsunyuan: P('gongsunyuan', '公孫淵', '自立燕王', 'neutral', '戰士', 'sword', { head: 'guan', eye: 'narrow', beard: 'goatee', bulk: 1.05, size: 1.1, c: { armor: '#5a3a6a', cloth: '#3a2448', cape: '#7a4a8a', plume: '#c0a0d0' } }, [
    ['燕王劍', 'crescent', '造成 {130/130/130/130} 傷害。'], ['突圍', 'charge', '衝撞造成 {110/110/110/110} 傷害。'], ['困獸', 'spin', '每圈 {60/60/60/60} 傷害。'], ['決死', 'slam', '{190/190/190} 傷害。']]),
  niujin: P('niujin', '牛金', '魏將', 'wei', '戰士', 'axe', { beard: 'bushy', bulk: 1.2, size: 1.1 }, [
    ['開山', 'crescent', '造成 {90/90/90/90} 傷害。'], ['輕騎', 'charge', '衝撞造成 {80/80/80/80} 傷害。'], ['迴斧', 'spin', '每圈 {45/45/45/45} 傷害。'], ['破陣', 'slam', '{140/140/140} 傷害。']]),
  huzun: P('huzun', '胡遵', '魏將', 'wei', '戰士', 'spear', { beard: 'mustache' }, [
    ['槍刺', 'crescent', '造成 {85/85/85/85} 傷害。'], ['突擊', 'charge', '衝撞造成 {75/75/75/75} 傷害。'], ['堅守', 'shield', '護身。'], ['陷陣', 'slam', '{130/130/130} 傷害。']]),
  simashi: P('simashi', '司馬師', '中護軍', 'wei', '戰士', 'sword', { head: 'guan', eye: 'narrow', c: { cape: '#3a2a5a', plume: '#8a6ad8' } }, [
    ['揮劍', 'crescent', '造成 {90/90/90/90} 傷害。'], ['突進', 'charge', '衝撞造成 {70/70/70/70} 傷害。'], ['屯門', 'shield', '護身。'], ['斷後', 'slam', '{130/130/130} 傷害。']]),
};

// 各家的兵
export const TR = {
  meng: troop('mengda-soldier', '孟達兵', { armor: '#4a5a3a', sleeve: '#2e3a26', cloth: '#2e3a26', plume: '#a0b070' }),
  liao: troop('liao-soldier', '遼東兵', { armor: '#4a3a5a', sleeve: '#2e2638', cloth: '#2e2638', plume: '#9a8ab0' }),
  shu: SG.SOLDIERS.shu, wu: SG.SOLDIERS.wu, wei: SG.SOLDIERS.wei,
  cao: troop('cao-soldier', '曹爽兵', { armor: '#7a6a3a', sleeve: '#4a4228', cloth: '#4a4228', plume: '#d0b050' }, SG.SOLDIERS.wei),
};

// 天數：從 V.t0 起算，每 day 秒一天
export const days = (m, w, day) => (w.t - m.vars.t0) / day;

// 讓村民（送信的人、百姓）往 (x, y) 走，到了回傳 true
export function walkTo(f, x, y, sp, dt) {
  const dx = x - f.x, dy = y - f.y, L = Math.hypot(dx, dy), s = sp * dt;
  f.still = true;
  if (L <= s) { f.x = x; f.y = y; f.walk = false; f.home = [x, y]; return true; }
  f.x += (dx / L) * s; f.y += (dy / L) * s; f.f = dx < 0 ? -1 : 1; f.walk = true; f.home = [f.x, f.y];
  return false;
}

// 雨幕：斜斜的雨絲，畫面略暗
export function rain(ctx, x0, y0, vw, vh, T, k = 1) {
  ctx.save();
  ctx.fillStyle = `rgba(30,40,56,${(0.32 * k).toFixed(3)})`; ctx.fillRect(x0, y0, vw, vh);
  ctx.strokeStyle = `rgba(200,215,230,${(0.35 * k).toFixed(3)})`; ctx.lineWidth = 1.5;
  ctx.beginPath();
  for (let i = 0; i < 140; i++) {
    const x = x0 + ((i * 137.5 + T * 90) % vw), y = y0 + ((i * 89.3 + T * 900) % vh);
    ctx.moveTo(x, y); ctx.lineTo(x - 10, y + 34);
  }
  ctx.stroke();
  ctx.restore();
}
// 夜色
export function night(ctx, x0, y0, vw, vh, a = 0.45) { ctx.fillStyle = `rgba(12,18,48,${a})`; ctx.fillRect(x0, y0, vw, vh); }

// 旗幟（疑兵、軍門）：f.text 是旗上的字
export function flag(ctx, f, T) {
  const { poly, caps } = SG.draw, wv = Math.sin(T * 3 + f.x * 0.01) * 4;
  ctx.save(); ctx.translate(f.x, f.y);
  SG.draw.castShadow(ctx, 0, 2, 16, 5, 60, 0.3);
  caps(ctx, [[[0, 0], [0, -120], 4, '#5b3d27']]);
  poly(ctx, [[2, -118], [52, -114 + wv], [50, -74 + wv], [2, -78]], f.col || '#3b5a99', 2);
  ctx.fillStyle = '#f2e6c8'; ctx.font = '900 22px "Noto Serif TC", serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
  ctx.fillText(f.text || '魏', 26, -96 + wv / 2);
  ctx.restore();
}
// 土山：堆起來的土丘，上面插一面小旗；f.k（0～1）是堆了多高
export function mound(ctx, f, T) {
  const k = f.k == null ? 1 : f.k;
  ctx.save(); ctx.translate(f.x, f.y);
  ctx.fillStyle = '#7a6440'; ctx.strokeStyle = '#3a2a18'; ctx.lineWidth = 2;
  ctx.beginPath(); ctx.moveTo(-90, 0); ctx.quadraticCurveTo(0, -110 * k, 90, 0); ctx.closePath(); ctx.fill(); ctx.stroke();
  if (k >= 1) flag(ctx, { x: 0, y: -100, text: '魏', col: '#3b5a99' }, T);
  ctx.restore();
}
// 床榻（詐病）：一張矮床，上面躺著的人由引擎畫
export function bed(ctx, f) {
  const { poly } = SG.draw;
  ctx.save(); ctx.translate(f.x, f.y);
  poly(ctx, [[-80, 10], [80, 10], [80, -14], [-80, -14]], '#6a4a2e', 2);
  poly(ctx, [[-84, -14], [84, -14], [80, -24], [-80, -24]], '#c8b890', 1.6);
  poly(ctx, [[-84, -24], [-70, -24], [-70, -60], [-84, -60]], '#5a3a22', 1.6);
  ctx.restore();
}
